export default "__VITE_ASSET__Do8Nl9Lc__"